<template>
    <div v-if="imageToShow" class="relative overflow-hidden">
        <picture>
            <source media="(max-width: 1023px)" :srcset="imageToShow.url_mobile ?? imageToShow.url">
            <source media="(min-width: 1024px)" :srcset="imageToShow.url">

            <img
                class="absolute h-full w-full inset-0 object-cover transition-transform duration-500"
                :class="{
                    'scale-100 group-hover:scale-105': isPremier,
                }"
                loading="lazy"
                :alt="imageToShow.alt ?? ''"
                :style="{
                    objectPosition: `${imageToShow.focalPoint?.[0] * 100 ?? '50'}% ${imageToShow.focalPoint?.[1] * 100 ?? '50'}%`,
                }"
            >
        </picture>
    </div>
</template>

<script setup>
    const { digistormSettings } = storeToRefs(useSiteStore())

    const props = defineProps({
        image: {
            type: [Object, Array],
        }
    })

    const isPremier = computed(() => {
        return digistormSettings.value?.websiteTier === 'premier'
    })

    const imageToShow = computed(() => {
        if (isArray(props.image)) {
            return props.image.length > 0 ? props.image[0] : null
        }
        return props.image
    })
</script>
